<template>
	<div style="padding-left: 10px;padding-right: 10px;padding-top: 10px;">
		<van-list :finished="true">
			<div v-for="customer in customerList" style="border-bottom:0.1px solid #9095A6;">
				<div style="padding: 10px;background-color: #FFF;">
					<Row justify="space-between" class="code-row-bg">
						<p style="text-indent: 0em; font-size: 16px;font-weight :bold;">{{ (customer.rep === 0 ?
                            $t('msg.userCustomer') :
                            $t('msg.serviceReply')) }} </p>
						<p style="color: #9095A6;">{{ formatDate(new Date(customer.createTime / 1), 'yyyy-MM-dd hh:mm:ss')
                        }}</p>
					</Row>
					<Row justify="space-between" class="code-row-bg">
						<Col :span="customer.imgUrl != '' && customer.imgUrl != null ? '18' : 'auto'">
						<p style="text-indent: 2em;word-wrap:break-word; margin-top: 8px;">{{ customer.repair }}</p>
						</Col>
						<Col span="6" v-if="customer.imgUrl != '' && customer.imgUrl != null">
						<div @click="handleShowPreview(customer.imgUrl)" style="text-align: center;padding-top: 10px;">
							<Image :src="customer.imgUrl" width="70px" height="90px">
								<template #error>
									<Icon type="ios-image-outline" size="24" color="#ccc" />
								</template>
							</Image>
						</div>
						</Col>
					</Row>
				</div>
			</div>
		</van-list>
	</div>

	<ImagePreview v-model="preview" :preview-list="urlList" />
</template>

<script>
	import http from '../utils/request.js'
	import api from '../api/index.js'
	export default {
		components: {},
		data() {
			return {
				newForm: {
					id: ''
				},
				urlList: [],
				customerList: [],
				preview: false,

			}
		},
		methods: {
			handleShowPreview(imgUrl) {
				this.preview = true;
				this.urlList = [imgUrl];
			},
			getCustomerList() {
				api.systemServiceApi.getCustomerInfos(this.newForm)
					.then((result) => {
						this.customerList = result;
					});
			},
			formatDate(date, format) {
				let time = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate(),
					'h+': date.getHours(),
					'm+': date.getMinutes(),
					's+': date.getSeconds(),
					'q+': Math.floor((date.getMonth() + 3) / 3),
					'S+': date.getMilliseconds()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' +
							time[k]).length));
					}
				}
				return format;
			}
		},
		mounted() {
			this.newForm.id = this.$route.query.id;
			this.getCustomerList();
			document.querySelector('body').setAttribute('style', 'background-color:#eff2f5');
			document.title = this.$t('msg.recordDetails')
		}
	}
</script>